'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var bootsSizeValues = {
    36: 'EU 36 (US Men 4 / US Women 5.5 / UK Men 3 / UK Women 3.5)',
    37: 'EU 37 (US Men 5 / US Women 6.5 / UK Men 4 / UK Women 4.5)',
    38: 'EU 38 (US Men 6 / US Women 7.5 / UK Men 5 / UK Women 5.5)',
    39: 'EU 39 (US Men 6.5 / US Women 8.5 / UK Men 6 / UK Women 6.5)',
    40: 'EU 40 (US Men 7 / US Women 9.5 / UK Men 6.5 / UK Women 7.5)',
    41: 'EU 41 (US Men 8 / US Women 10.5 / UK Men 7.5 / UK Women 8.5)',
    42: 'EU 42 (US Men 9 / US Women 11 / UK Men 8.5 / UK Women 9)',
    43: 'EU 43 (US Men 10 / US Women 12 / UK Men 9.5 / UK Women 10)',
    44: 'EU 44 (US Men 11 / UK Men 10.5)',
    45: 'EU 45 (US Men 12 / UK Men 11.5)',
    46: 'EU 46 (US Men 13 / UK Men 12.5)',
    47: 'EU 47 (US Men 14 / UK Men 13.5)',
    48: 'EU 48 (US Men 15 / UK Men 14.5)',
    49: 'EU 49 (US Men 16 / UK Men 15.5)',
    50: 'EU 50 (US Men 17 / UK Men 16.5)'
};

exports.default = bootsSizeValues;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/boots_size/bootsSizeValues.js
// module id = 1369
// module chunks = 0